<template lang="pug">
div
  dashboard-view(v-if="['admin', 'store'].includes(user.role)")
  home-driver(v-else-if="user.role === 'delivery'")
</template>

<script>
import { mapGetters } from 'vuex'
import HomeDriver from '../components/home/HomeDriver'
import ListStoreDelivery from '../components/delivery/ListStoreDelivery'
import DashboardView from './DashboardView.vue'

export default {
  components: {
    HomeDriver,
    DashboardView
  },
  computed: {
    ...mapGetters(['user', 'deliveries'])
  }
}
</script>
